export default {
  home: 'Home',
  manageUser: 'Manage User',
  pleaseLogIn: 'Please log in',
  username: 'Username',
  password: 'Password',
  confirmPassword: 'Confirm Password',
  confirm: 'Confirm',
  rememberMe: 'Remember me',
  forgotPassword: 'Forgot password',
  language: 'Language',
  selectLanguage: 'Select Language',
  thai: 'Thai',
  english: 'English',
  login: 'Login',
  vision: 'Vision',
  mission: 'Mission',
  value: 'Value',
  swotAnalysis: 'SWOT Analysis',
  company: 'Company',
  competencyScore: 'Competency Score',
  competencyScoreGroup: 'Competency Score Group',
  competencyScoreGroupName: 'Competency Score Group Name',
  addGroup: 'Add Group',
  filter: 'Filter',
  search: 'Search',
  cancel: 'Cancel',
  corporate: 'Corporate',
  companyCode: 'Company Code',
  companyName: 'Company Name',
  lineBusiness: 'Line Business',
  active: 'Active',
  inactive: 'Inactive',
  export: 'Export',
  import: 'Import',
  download: 'Download',
  searchFor: 'Search for',
  general: 'General',
  parentCompany: 'Parent company',
  about: 'About',
  config: 'Config',
  save: 'Save',
  file: 'File',
  saveAndAddAnother: 'Save & Add Another',
  passwordPolicy: 'Password Policy',
  passwordExpiration: 'Password Expiration',
  ldap: 'LDAP',
  createby: 'Create by',
  eMailServer: 'e-Mail Server',
  updateby: 'Update by',
  dataIntegration: 'Data Integration',
  lastExecute: 'Last Execute',
  selectTable: 'Select Table',
  destinationTable: 'Destination Table',
  sourceConnection: 'Source Connection',
  sqlSourceTable: 'SQL Source Table',
  execute: 'Execute',
  sampleData: 'Sample Data',
  getField: 'Get Field',
  mappingField: 'Mapping Field',
  sourceField: 'Source Field',
  destinationField: 'Destination Field',
  add: 'Add ',
  del: 'Del',
  namePasswordPolicy: 'Name Password Policy',
  changeable: 'Changeable',
  minimumAge: 'Minimum Age',
  resetTicketMaxAge: 'Reset Ticket Max Age',
  passwordSyntaxchecking: 'Password Syntaxchecking',
  syntaxCheckingEnabled: 'Syntax Checking Enabled',
  historyEnabled: 'History Enabled',
  minimumAlphaNumeric: 'Minimum Alpha Numeric',
  minimumLength: 'Minimum Length',
  minimumLowerCase: 'Minimum Lower Case',
  minimumNumbers: 'Minimum Numbers',
  minimumSymbols: 'Minimum Symbols',
  minimumUpperCase: 'Minimum Upper Case',
  regularExpression: 'Regular Expression',
  passwordHistory: 'Password History',
  historyExpriation: 'History Expriation',
  maximemAge: 'Maximem Age',
  warningTime: 'Warning Time',
  graceLimit: 'Grace Limit',
  lockout: 'Lockout',
  lockoutEnabled: 'Lockout Enabled',
  maximumFailure: 'Maximum Failure',
  resetFailureCount: 'Reset Failure Count',
  lockoutDuration: 'Lockout Duration',
  serverName: 'Server Name',
  baseProviderURL: 'Base Provider URL',
  baseDN: 'Base DN',
  users: 'Users',
  userMapping: 'User Mapping',
  uuid: 'UUID',
  emailAddress: 'Email Address',
  firstName: 'First Name',
  lastName: 'Last Name',
  groupMapping: 'Group Mapping',
  groupName: 'Group Name',
  testldapGroups: 'Test LDAP Groups',
  organization: 'Organization',
  code: 'Code',
  organizationName: 'Organization Name',
  organizationLevel: 'Organization Level',
  parentCode: 'Parent Code',
  level: 'Level',
  abbreviation: 'Abbreviation',
  eMail: 'E-Mail',
  effectiveDate: 'Effective Date',
  position: 'Position',
  positionName: 'Position Name',
  positionGroup: 'Position Group',
  positionGroupCode: 'Position Group Code',
  seqNo: 'Seq No',
  positionGroupName: 'Position Group Name',
  role: 'Role',
  roleName: 'Role Name',
  admin: 'Admin',
  dataAccess: 'Data Access',
  access: 'Access',
  specificCompany: 'Specific Company',
  specificOrg: 'Specific Org',
  orgHierarchy: 'Org Hierarchy',
  ownOrg: 'Own Org',
  orgLevel: 'Org Level',
  page: 'Page',
  pageAccess: 'Page Access',
  assignUser: 'Assign User',
  assignRole: 'Assign Role',
  view: 'View',
  edit: 'Edit ',
  delete: 'Delete ',
  setupData: 'Setup Data',
  user: 'User',
  userName: 'UserName',
  manage: 'Manage',
  appraisalFormName: 'Appraisal Form Name',
  appraisalYear: 'Appraisal Year',
  startDate: 'Start Date',
  endDate: 'End Date',
  structure: 'Structure',
  structureName: 'Structure Name',
  structureType: 'Structure Type',
  targetScore: 'Target Score',
  orderSeq: 'Order Seq',
  valueGetZero: 'Value Get Zero',
  unlimitedDeduction: 'Unlimited Deduction',
  permission: 'Permission',
  appraisalType: 'Appraisal Type',
  levelName: 'Level Name',
  parentLevel: 'Parent Level',
  midpoint: 'Midpoint',
  district: 'District',
  appraisalCriteria: 'Appraisal Criteria',
  appraisalLevel: 'Appraisal Level',
  appraisalCriteriaName: 'Appraisal Criteria Name',
  setWeight: 'Set Weight',
  setAssessor: 'Set Assessor',
  setPosition: 'Set Position Group',
  select: 'Select ',
  group: 'Group',
  caseNo: 'Case No.',
  appraisal: 'Appraisal',
  appraisalItem: 'Appraisal Item',
  appraisalItemCode: 'Appraisal Item Code',
  appraisalItemName: 'Appraisal Item Name',
  header: 'Header',
  itemCode: 'Item Code',
  kpiType: 'KPI Type',
  kpiTypeName: 'KPI Type Name',
  kpiParent: 'Parent KPI',
  parentItem: 'Parent Item',
  parentName: 'Parent Name',
  uom: 'UOM',
  perspective: 'Perspective',
  perspectiveName: 'Perspective Name',
  valueType: 'Value Type',
  functionType: 'Function Type',
  formula: 'Formula',
  formulaDescription: 'Formula Description',
  performanceLevel: 'Performance Level',
  description: 'Description',
  isShowVariance: 'Is Show Variance',
  competencyType: 'Competency Type',
  proficiencyLevel: 'Proficiency Level',
  deductName: 'Deduct Name',
  maxValue: 'Max Value',
  deductScoreUnit: 'Deduct Score/Unit',
  status: 'Status',
  copyTo: 'Copy To',
  copyAssignment: 'Copy Assignment',
  companyInfo: 'Company Info',
  form: 'Form',
  formName: 'Form Name',
  assign: 'Assign ',
  unassign: 'Unassigned ',
  assignment: 'Assignment ',
  assignDate: 'Assign Date',
  structureWeight: 'Structure Weight',
  condition: 'Condition',
  threshold: 'Threshold',
  thresholdGroup: 'Threshold Group',
  prorate: 'Prorate',
  approve: 'Approve',
  kpi: 'KPI',
  kpiCode: 'KPI Code',
  kpiName: 'KPI Name',
  target: 'target',
  frequency: 'Frequency',
  daily: 'Daily',
  weekly: 'Weekly',
  quarterly: 'Quarterly',
  monthly: 'Monthly',
  halfYearly: 'Half Yearly',
  biannually: 'Biannually',
  yearly: 'Yearly',
  weightPercent: '%Weight',
  weightScore: 'Weight Score',
  waive: 'Waive',
  deployable: 'Deployable',
  adoptable: 'Adoptable',
  applyAll: 'Apply All',
  responsible: 'Responsible',
  remark: 'Remark',
  action: 'Action ',
  review: 'Review ',
  draft: 'Draft',
  reject: 'Reject',
  start: 'Start',
  end: 'End',
  all: 'All',
  totalPercentWeight: 'Total %Weight ',
  totalScore: 'Total Score',
  expectation: 'Expectation',
  deduct: 'Deduct',
  addUser: 'Add User',
  individual: 'Individual',
  resultType: 'Result Type',
  color: 'Color',
  colorCode: 'Color Code',
  criteriaName: 'Criteria Name',
  empCode: 'Emp Code',
  employee: 'Employee',
  empType: 'Employee Type',
  employeeName: 'Employee Name',
  employeeLevel: 'Employee Level',
  calculate: 'Calculate',
  adjust: 'Adjust',
  adjustName: 'Adjust Name',
  setting: 'Setting',
  profile: 'Profile',
  signOut: 'Sign Out',
  minutes: 'Minutes',
  minute: 'Minute',
  hours: 'Hours',
  hour: 'Hour',
  week: 'Week',
  weeks: 'Weeks',
  year: 'Year',
  month: 'Month',
  day: 'Day',
  days: 'Days',
  details: 'Details',
  workingStartDate: 'Working Start Date',
  workingAge: 'Working Age',
  doNotWarn: 'Do not warn',
  unlockedByAdmin: 'Until unlocked by an administrator',
  max_validate: 'Input data size exceeds the allowed max size',
  unique_validate: 'Data already exists',
  numeric_validate: 'Data must be numbers',
  string_validate: 'Data must be strings',
  boolean_validate: 'Data must be true or false',
  between_validate: 'Data must be in allowed range',
  required_validate: 'Data is required',
  exists_validate: 'No key exists',
  date_validate: 'Data must be in valid date format',
  '2000': 'This record is being used, cannot delete',
  '2002': 'This record is already exists',
  is_Main: 'Is Main',
  action_To: 'Action To',
  delegate: 'Delegate',
  assignmentDate: 'Assign Date',
  confirmDel: 'Are you sure to delete this item?',
  forceRank: 'Force rank',
  criteria: 'Criteria',
  date: 'Date',
  summary: 'Summary',
  levelGroup: 'Level Group',
  levelGroupName: 'Level Group Name',
  addAssignment: 'Add Assignment',
  cancelAssignment: 'Cancel Assignment?',
  rejectReason: 'Reject Reason',
  confirmLeavePage: 'Are you sure to leave this page? Any unsaved data will be lost',
  weightValidationHelperText: 'Weight must be between 0 and 100',
  cannotDeployMultiTarget:
    'Cannot not adopt KPI for multiple assignee, please remove assignee targets.',
  addItem: 'Add KPI',
  removeItem: 'Remove KPI',
  totalWeightValidationHelperText: 'Total Weight must equal to 100',
  totalValidation: 'Total Weight must equal to ',
  targetValue: 'Target Value',
  targetRange1: 'Target Range 1',
  targetRange2: 'Target Range 2',
  targetRange3: 'Target Range 3',
  targetRange4: 'Target Range 4',
  targetRange5: 'Target Range 5',
  actualValue: 'Actual Value',
  jan: 'Jan',
  feb: 'Feb',
  mar: 'Mar',
  apr: 'Apr',
  may: 'May',
  jun: 'Jun',
  jul: 'Jul',
  aug: 'Aug',
  sep: 'Sep',
  oct: 'Oct',
  nov: 'Nov',
  dec: 'Dec',
  q1: 'QTR 1',
  q2: 'QTR 2',
  q3: 'QTR 3',
  q4: 'QTR 4',
  half1: '1st Half',
  half2: '2nd Half',
  competencyCode: 'Competency Code',
  competencyName: 'Competency Name',
  score: 'Score',
  overValue: 'Over Value',
  comment: 'Comment',
  reply: 'Reply',
  cancelAppraisal: 'Cancel Appraisal?',
  assignCompleted: 'Assigned (Completed)',
  assignIncompleted: 'Assigned (Incompleted)',
  commentRequiredWhenScoreOver80Percent: 'Comment is required when score is over 80% of target',
  scoreIsHigherThanTarget: 'Score cannot be greater than target score',
  resulted: 'Resulted',
  notResulted: 'Not Resulted',
  assessor: 'Assessor',
  assessorGroup: 'Assessor Group',
  assignmentEndDate: 'Assignment End Date',
  performanceTrend: 'Performance Trend',
  usageLog: 'Usage Log',
  usageDateTime: 'Usage DateTime',
  fullName: 'Full Name',
  pageName: 'Page Name',
  dataId: 'Data ID',
  tableUsageLog: 'Usage Log',
  grade: 'Grade',
  no: 'No',
  forceRankIndex: 'Force Rank Index',
  indexTable: 'Index Table',
  adjustGradeTable: 'Adjust Grade Table',
  individualKPI: 'KPI',
  attendance: 'Attendance',
  dashboardBranchPerformance: 'Branch Performance',
  dashboardOverallPerformance: 'Overall Performance',
  dashboardPerformanceComparison: 'Performance Comparison',
  dashboardPerformanceTrend: 'Performance Trend',
  reportAppraisal: 'Appraisal Summary',
  reportDataEntry: 'Data Entry Status',
  reportKpi: 'KPI Summary',
  reportPerformanceForm: 'Performance Form',
  branchPerformance: 'Branch Performance',
  overallPerformance: 'Overall Performance',
  performanceComparison: 'Performance Comparison',
  appraisalSummary: 'Appraisal Summary',
  dataEntryStatus: 'Data Entry Status',
  kpiSummary: 'KPI Summary',
  performanceForm: 'Performance Form',
  dashboard: 'Dashboard',
  report: 'Report',
  'unable-to-assign-competency-because-the-result-action2-was-not-found':
    'Unable to assign competency because there is no assessor',
  deleteComment: 'Delete Comment',
  confirmDeleteData: 'Will the calculated data be deleted, confirmed or not?',
  confirmClearGrade: 'Grade information will be cleared. Confirm or not?',
  individualAssignment: 'Individual Assignment',
  corporateAssignment: 'Corporate Assignment',
  setOption: 'Set Option',
  province: 'Province',
  channel: 'Channel',
  selectAll: 'Select All',
  LOW: 'Low',
  MED: 'Medium',
  HIGHT: 'Hight',
  '400': 'Invalid data',
  '401SE': 'Session Expired, please login again',
  '401LI': 'Username or password is invalid',
  '401NA': 'You are not authorized to access this data',
  '404': 'Data not found',
  '500': 'Server Error, please try again later',
  alertGrade: 'Error : Grade is not equal to amount',
  budget: 'Budget',
  amount: 'Amount',
  indexCalculation: 'Index calculation',
  AdjustGrade: 'Force rank',
  ForceRankSuccess: 'Force rank success',
  SomeStatusNotClose: 'Some status not close',
  IndexCalculateSuccess: 'Index calculate success',
  AdjustGradeCreated: 'Adjust grade created',
  InvalidAdjustGradeField: 'Invalid adjust grade field',
  ForceRankFaild: 'Force rank faild',
  'LOWX,LOWY': 'LOWX,LOWY',
  'LOWX,MEDY': 'LOWX,MEDY',
  'LOWX,HIGHY': 'LOWX,HIGHY',
  'LOWX,HIGHERY': 'LOWX,HIGHERY',
  'MEDX,LOWY': 'MEDX,LOWY',
  'MEDX,MEDY': 'MEDX,MEDY',
  'MEDX,HIGHY': 'MEDX,HIGHY',
  'MEDX,HIGHERY': 'MEDX,HIGHERY',
  'HIGHX,LOWY': 'HIGHX,LOWY',
  'HIGHX,MEDY': 'HIGHX,MEDY',
  'HIGHX,HIGHY': 'HIGHX,HIGHY',
  'HIGHX,HIGHERY': 'HIGHX,HIGHERY',
  'HIGHERX,LOWY': 'HIGHERX,LOWY',
  'HIGHERX,MEDY': 'HIGHERX,MEDY',
  'HIGHERX,HIGHY': 'HIGHERX,HIGHY',
  'HIGHERX,HIGHERY': 'HIGHERX,HIGHERY',
  LOWX: 'LOW',
  LOWY: 'LOW',
  MEDX: 'MED',
  MEDY: 'MED',
  HIGHX: 'HIGH',
  HIGHY: 'HIGH',
  HIGHERX: 'HIGHER',
  HIGHERY: 'HIGHER',
  IndexCalculateTab: 'Index Calculation',
  ForceRankTab: 'Force Rank',
  example: 'Example',
  noRecordsToDisplay: 'No records to display',
  close: 'Close',
  next: 'Next',
  previous: 'Previous',
  back: 'Back',
  assignmentEndDateValidation: 'End date must not less than assignment date',
  assessorScore: 'Assessor Score',
  'emp-action-2-not-found': 'This employee has no assessor',
  thresholds: 'Thresholds',
  pageNotFound: 'Page not found on requested path',
  showing: 'Showing',
  records: 'Records',
  of: 'of',
  achievement: 'Achievement',
  perspectivePerformance: 'Perspective Performance',
  kpiPerformance: 'KPI Performance',
  allKpi: 'All KPI',
  impactLevel: 'Impact Level',
  urgencyLevel: 'Urgency Level',
  actual: 'actual',
  percentAchievement: '% Achievement',
  atDate: 'at date',
  expandAll: 'expand all',
  collapseAll: 'collapse all',
  noDataDisplay: 'No Data Display',
  roleAssignment: 'Role Assignment',
  getPassword: 'Get Password',
  forgetPassword: 'Forget Password',
  getPasswordInEmail: 'You can get your new password in your email',
  confirmation: 'Confirmation',
  isDate: 'Is Date',
  format: 'Format',
  pleaseFilter: 'Please Filter...',
  pagiPage: 'Page No',
  pagiPerPage: 'Per Page',
  tag: 'Tag',
  competencyMax: 'Competency Max',
  accomplishmentFrom: 'Get Result From',
  commentRequiredWhenScoreEqualOrOverExpectation:
    'Comment is required when score is equal or higher than expectation',
  precisionIsNotEven: 'Precision is not even',
  positionGroupLevel: 'Position Group Level',
  allCompany: 'All Company',
  positionGroupLevelAccess: 'Position Group Level Access',
  addCase: 'Add Case',
  stage: 'Stage',
  competency: 'Competency',
  task: 'Task',
  actualStart: 'Actual Start',
  actualEnd: 'Actual End',
  planStart: 'Plan Start',
  planEnd: 'Plan End',
  phase: 'Phase',
  actionPlan: 'Action Plan',
  taskNameIsRequired: 'Task Name is required',
  commentIsRequired: 'Comment is required',
  totalGradeValidationHelperText: 'Total Grade must equal to 100 or 0',
  totalGradeValidationText: 'Total Grade must equal to 100',
  gradeCriteria: 'Grade Criteria',
  gradeCriteriaName: 'Grade Criteria Name',
  gradeCondition: 'Grade Condition',
  beginScore: 'Begin Score',
  endScore: 'End Score',
  salaryRaise: '% Salary Raise',
  percentBudget: 'Percent Budget',
  bonusMonth: 'Bonus Month',
  performance: 'Performance',
  valueIsHigherThanCompetencyMax: 'Value should not higher than competency max',
  importSalary: 'Import Salary',
  browseOrDropFileHere: 'Browse or drop file here',
  salary: 'Salary',
  salaryData: 'Salary Data',
  forceRankGroup: 'Force Rank Group',
  forceRankGroupName: 'Force Rank Group Name',
  budgetSalary: 'Budget Salary',
  budgetBonus: 'Budget Bonus',
  isForceRank: 'Is Force Rank',
  sumUp: 'Sum Up',
  calLoading: 'Calculating',
  loading: 'Loading',
  actualGrade: 'Actual Grade',
  forceRankHorizontal: 'Horizontal Force rank',
  forceRankHorizontalDirec: 'Horizontal Force rank (Director)',
  forceRankHorizontalBoard: 'Horizontal Force rank (Board)',
  forceRankVertical: 'Vertical Force rank',
  raiseAmount: 'Raise Amount',
  extraRaiseAmount: 'Extra Raise Amount',
  extraRaise: 'Extra Raise%',
  extraBonusMonth: 'Extra Bonus Month',
  extraBonus: 'Extra Bonus',
  finalBonus: 'Final Bonus',
  raise: 'Raise%',
  newSalary: 'New Salary',
  bonus: 'Bonus',
  old: 'Old',
  raiseReverse: '%Raise',
  numberOfEmployee: 'Number of Employees',
  difference: 'Difference',
  forceRankTable: 'Force Rank Table',
  total: 'Total',
  commentIsRequiredMin150: 'Comment is required with 150 minimum characters',
  commentIsRequiredMin100: 'Comment is required with 100 minimum characters',
  sumIsNot100: 'Sum is not 100',
  reportAppraisalByOrg: 'Appraisal Summary By Org',
  reportAppraisalByLevel: 'Appraisal Summary By Level',
  reportAppraisalByJobKpi: 'Appraisal Summary Report by Job KPI',
  reportBonusSalary: 'Bonus Salary',
  probationEndDate: 'Probation End Date',
  coachingAndFeedback: 'Coaching and Feedback',
  feedback: 'Feedback',
  feedbackReport: 'Feedback Report',
  is_vfr: 'Is_VFR'
}
